import { render } from "./Read.vue?vue&type=template&id=74b1f6b9&scoped=true"
import script from "./Read.vue?vue&type=script&lang=js"
export * from "./Read.vue?vue&type=script&lang=js"

import "./Read.vue?vue&type=style&index=0&id=74b1f6b9&scoped=true&lang=css"

import exportComponent from "D:\\WORKSPACE\\Netbeans\\lz06\\2022xiongmao\\xiongmao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b1f6b9"]])

export default __exports__